<template>
  <article class="flex flex-col">
    <h1
      class="mb-[24px] text-center font-roboto text-[32px] font-medium leading-6 text-specialprojectsection"
    >
      События
    </h1>
    <CommonComplexFiltering
      v-if="false"
      :key="isAnyFiltersActive"
      class="mb-[20px]"
      :sort-options="sortOptions"
      :filters-active="filters"
      is-centuries-disabled
    />
    <div class="-m-2.5 flex flex-wrap">
      <MainPageCardsReworkedNewsCard
        v-for="newsItem in news?.data?.value?.data"
        :key="newsItem.id"
        class="w-full max-w-[100%] p-2.5 md:max-w-[50%]"
        :data="newsItem"
      />
    </div>
    <BaseThePagination :entity="news" />

    <!-- <div class="mt-[64px] flex justify-center">
      <BaseTheButtonNew
        v-if="news.hasNextPage.value"
        text="Показать еще"
        @click="news.fetchNextPage()"
      />
    </div> -->
  </article>
</template>

<script setup>
const route = useRoute();
const router = useRouter();

const filters = computed(() => {
  return {
    sort_by: route.query?.sort_by,
  };
});

const page = computed(() => Number(route.query?.page) || 1);
const { news, resetPage } = useNews({ filters, per_page: 8, page });

watch(filters, (newValue, prevValue) => {
  if (JSON.stringify(newValue) === JSON.stringify(prevValue)) return;
  router.push({ query: { ...route.query, page: undefined } });
  resetPage(prevValue);
});

const isAnyFiltersActive = computed(() => Object.values(route.query).length);

const sortOptions = [
  { id: 0, label: 'Свежие', value: '', icon: 'timer' },
  {
    id: 1,
    label: 'Обсуждаемые',
    value: 'comments',
    icon: 'chat-circle',
  },
  { id: 2, label: 'Популярные', value: 'views', icon: 'eye' },
];

const { canonicalUrl, title } = useSeoHelper();

useHead(() => ({
  title: title('События истории РФ | Федеральный портал Истории России'),
  meta: [
    {
      hid: 'description',
      name: 'description',
      content:
        'События в истории России и всем, что с ней связано. Освещаем действительно важные события. Российское военно-историческое общество. Мы знаем правду.',
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: canonicalUrl.value,
    },
  ],
}));
</script>
